import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import Content from './Content';

const useStyles = buildUseStyles('FundingInstructionsPageTemplate', () => ({
  root: {},
}));

const FundingInstructionsPageTemplate = ({
  className,
  resource,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();

  const onNext = async () => {
    loadPageContentLink(resource.attr('accountFundingInstructions').resources().head().link('self'));
  };

  const handleGetStarted = (fundingInstruction) => {
    loadPageContentLink(fundingInstruction.link('self'));
  };

  const onClose = async () => {
    resource.withRelationship(fr.relationships.redirectOnClose.name, () => {
      loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    }, () => {
      history.push('/');
    });
  };

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={Content}
      LayoutProps={{
        resource,
        onGetStartedClick: handleGetStarted,
      }}
      onNext={onNext}
      resource={resource}
      primaryActionLabel={'Continue'}
      metaOverrideSet={BaseOverride}
      onClose={onClose}
    />
  );
};

FundingInstructionsPageTemplate.defaultProps = {
  className: '',
};

FundingInstructionsPageTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default FundingInstructionsPageTemplate;
